import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IUserDataInitialState {
  authToken: string;
  expiry: number;
  refreshInterval: number;
  refreshToken: string;
  userDetails: any;
}

const userDataInitialState: IUserDataInitialState = {
  authToken: '',
  expiry: 0,
  refreshInterval: 0,
  refreshToken: '',
  userDetails: null,
};

const userDataSlice = createSlice({
  name: 'userData',
  initialState: { ...userDataInitialState },
  reducers: {
    setUserData: (state, action: PayloadAction<object>) => ({ ...state, ...action.payload }),
    updateUserSetting: (state, action: PayloadAction<object>) => {
      const updatedState = JSON.parse(JSON.stringify(state));
      updatedState.userDetails.user_setting[0] = action.payload;
      return updatedState;
    },
  },
});

export const { setUserData, updateUserSetting } = userDataSlice.actions;
export default userDataSlice.reducer;
